import { render } from "./WalletExchangePositionsList.vue?vue&type=template&id=94b079bc&scoped=true"
import script from "./WalletExchangePositionsList.vue?vue&type=script&lang=js"
export * from "./WalletExchangePositionsList.vue?vue&type=script&lang=js"

import "./WalletExchangePositionsList.vue?vue&type=style&index=0&id=94b079bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94b079bc"]])

export default __exports__